import React, { Children, FC } from 'react';
import TableCell from '../TableCell/TableCell';

export interface TableRowProps {
  children: React.ReactNode;
  header?: boolean;
}

const TableRow: FC<TableRowProps> = ({ children, header = false }) => {
  const arrayChildren = Children.toArray(children);

  return (
    <tr>
      {Children.map(arrayChildren, (child) => (
        <TableCell header={header}>{child}</TableCell>
      ))}
    </tr>
  );
};

export default TableRow;
